<template>
  <div>
    <fund-selector @fund-selected="onFundSelected($event)" />
    <suspicious-variations
      v-if="selectedFund"
      ref="SuspiciousVariations"
      :fundId="selectedFund.key"
      @editReport="editReport($event)"
    />
    <a-drawer
      :title="reportDrawerTitle"
      width="600"
      placement="right"
      :visible="showEditReportDrawer"
      @close="onEditReportDrawerClosed()"
    >
      <edit-fund-monthly-report
        v-if="selectedReport"
        :report="selectedReport"
        @reportSaved="onReportUpdated($event)"
        @cancelButtonClicked="showEditReportDrawer = false"
      />
    </a-drawer>
  </div>
</template>

<script>
import FundSelector from '../components/FundReporting/FundSelector.vue'
import SuspiciousVariations from '../components/FundReporting/SuspiciousVariations.vue'
import EditFundMonthlyReport from '../components/FundReporting/EditFundMonthlyReport.vue'

export default {
  components: {
    SuspiciousVariations,
    EditFundMonthlyReport,
    FundSelector,
  },
  data() {
    return {
      selectedFund: null,
      selectedReport: null,
      showEditReportDrawer: false,
    }
  },
  computed: {
    reportDrawerTitle() {
      if (!this.selectedReport) {
        return ''
      }
      if (!this.selectedFund) {
        return ''
      }
      return `${this.selectedFund.name} - ${this.selectedReport.year}/${this.selectedReport.month}`
    },
  },
  methods: {
    onFundSelected(payload) {
      this.selectedFund = payload.fund
    },
    onEditReportDrawerClosed() {
      this.showEditReportDrawer = false
    },
    onReportUpdated() {
      this.$refs.suspiciousVariations.reload()
      this.showEditReportDrawer = false
    },
    editReport(period) {
      this.selectedReport = {
        fundId: this.selectedFund.key,
        year: period.year,
        month: period.month,
      }
      this.showEditReportDrawer = true
    },
  },
}
</script>

<style></style>
